import { closestCenter, DndContext, MeasuringStrategy } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Stack, Typography } from '@mui/material';
import { AddBlockMenu } from 'src/pages/Settings/memberships/components/landing-page-tab/add-block-menu';
import { SortableBlockItem } from 'src/pages/Settings/memberships/components/landing-page-tab/sortable-block-item';
import { blockListIntroSx } from 'src/pages/Settings/memberships/components/landing-page-tab/styled';
import { PlansList } from 'src/pages/Settings/memberships/components/plans-tab/styled';
import { useLandingPageBlocks } from 'src/pages/Settings/memberships/hooks/use-landing-page-blocks';

const INTRO =
  'Blocks compose the page top to bottom. Drag to reorder. Plans and FAQ stay in sync with your membership configuration.';

interface LandingPageContentTabProps {
  readOnly: boolean;
}

export const LandingPageContentTab = ({ readOnly }: LandingPageContentTabProps) => {
  const {
    fields,
    blockIds,
    presentTypes,
    expandedBlockIds,
    sensors,
    handleExpandedChange,
    handleDragStart,
    handleDragEnd,
    handleMove,
    handleAdd,
    handleRemove,
  } = useLandingPageBlocks(readOnly);

  return (
    <Stack flex={1} direction="column">
      <Typography variant="body2" color="text.secondary" sx={blockListIntroSx}>
        {INTRO}
      </Typography>

      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        // Rows change height as blocks expand and collapse, so cached measurements go stale.
        measuring={{ droppable: { strategy: MeasuringStrategy.Always } }}
      >
        <SortableContext items={blockIds} strategy={verticalListSortingStrategy}>
          <PlansList>
            {fields.map((field, index) => (
              <SortableBlockItem
                key={field._fieldId}
                index={index}
                blockId={field.id}
                type={field.type}
                expanded={expandedBlockIds.includes(field.id)}
                onExpandedChange={handleExpandedChange}
                onRemove={handleRemove}
                onMove={handleMove}
                moveUpToIndex={index > 0 ? index - 1 : null}
                moveDownToIndex={index < fields.length - 1 ? index + 1 : null}
                readOnly={readOnly}
              />
            ))}
          </PlansList>
        </SortableContext>
      </DndContext>

      {!readOnly ? <AddBlockMenu presentTypes={presentTypes} onAdd={handleAdd} /> : null}
    </Stack>
  );
};
